import z from "zod";

import { IconBaseSchema } from "@shared/content-types/schemas/common.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";
import { createComponentSchemas } from "@shared/content-types/utils";

const BannerBaseSchema = z.object({
  isVisible: z.boolean().optional().default(true),
  title: z.string().min(1),
  description: z.string().optional().nullable(),
  icon: IconBaseSchema.nullable(),
  photo: StrapiMediaSchema.nullable(),
  buttonText: z.string().min(1).optional().nullable(),
  buttonLink: z.string().min(1).optional().nullable(),
});

export const BannerSection = createComponentSchemas(
  "sections.banner",
  BannerBaseSchema,
);
